import { Component, computed, inject, input, output, viewChild, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { environment } from '@src/environments/environment';
import { ToolbarMenuCommandType, ToolbarMenuId } from '@src/suite/common/enums/enums';
import { MenuItem } from '@src/suite/common/st-full-screen-dialog/stories-full-screen/story-full-screen/story-actions';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

import { ClickStopPropagationDirective } from '../../../directives/stop-propagation';
import { BetaComponent } from '../../beta/st-beta.component';

@Component({
    selector: 'st-toolbar-menu',
    imports: [BetaComponent, ClickStopPropagationDirective, MatCheckbox, MatDivider, MatIcon, MatIconButton, MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger, MatTooltip],
    templateUrl: './toolbar-menu.component.html',
    styleUrl: './toolbar-menu.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-toolbar-menu',
    },
})
export class ToolbarMenuComponent {
    store = inject(Store);
    readonly items = input<MenuItem[] | undefined>([]);
    readonly baseMenu = viewChild.required<MatMenu>('baseMenu');
    readonly action = output<MenuItem>();

    ToolbarMenuId = ToolbarMenuId;
    ToolbarMenuCommandType = ToolbarMenuCommandType;

    languageSettings = this.store.selectSignal(selectI18N)();
    environment = environment;

    readonly localItems = computed(() => {
        if (!environment?.demoFlag) {
            return this.items()?.filter(item => item.id !== ToolbarMenuId.STORY_GENERATE);
        }
        return this.items();
    });

    onActionClick(item: MenuItem) {
        if (item) {
            this.action.emit(item);
        }
    }

    onAdditionalDeleteBtnClick(item: MenuItem) {
        const deleteItem: MenuItem = { ...item, id: ToolbarMenuId.TEMPLATE_DELETE };
        this.action.emit(deleteItem);
    }
}
